import { SvgIcon, SvgIconProps } from '@mui/material';

const AnalyticsOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="AnalyticsOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M2 3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3V15H6.51855L10.2188 10.375L10.2852 10.2998C10.6319 9.94505 11.1946 9.89652 11.5996 10.2002L14.5449 12.4092L17.1787 5.6377L17.2266 5.53418C17.35 5.29983 17.5622 5.12241 17.8184 5.04395C18.1111 4.95432 18.429 5.00349 18.6807 5.17773L21.5693 7.17773L21.6504 7.24023C22.0358 7.56937 22.117 8.14364 21.8223 8.56934C21.5275 8.99507 20.9613 9.12107 20.5176 8.87598L20.4307 8.82227L18.583 7.54297L15.9316 14.3623C15.8183 14.6538 15.5752 14.876 15.2744 14.9619C14.9738 15.0477 14.6505 14.9873 14.4004 14.7998L11.1758 12.3809L7.78125 16.625C7.59148 16.8622 7.30378 17 7 17H4V20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V3Z" />
    </SvgIcon>
  );
};

export default AnalyticsOutlined;
